module.exports = __webpack_public_path__ + "static/compas-e90fb224e6a52ce3c6f583ba1d13de91.png";